import axios from 'axios';

const state = {
    cartItems: { totalQty: 0, totalPrice:0, basketItems :[]}
}

const mutations = {
    UPDATE_CART_ITEMS(state, payload) {
        state.cartItems = payload;
    }
}

const actions = {
    getCartItems({ commit }, id) {
        //console.log('cart item', id);
        if (id != undefined) {
            axios.get('/api/cart/' + id).then((response) => {

                //console.log('Cart Items: ',response.data);
                commit('UPDATE_CART_ITEMS', response.data)
            });
        }
    },
    addCartItem({ commit }, cartItem) {
        return new Promise((resolve) => {
            axios.post('/api/cart', cartItem).then((response) => {
                //console.log(response);
                if (response.data.success) {
                    //console.log('addCartItem: ', response.data.object);
                    commit('UPDATE_CART_ITEMS', response.data.object)
                }
                resolve(response);
            });
            //axios.post('/api/cart/stock/check', cartItem).then((responseStock) => {
            //    // check stock
            //    if (responseStock.data == 1) {
            //        axios.post('/api/cart', cartItem).then((response) => {
            //            commit('UPDATE_CART_ITEMS', response.data)
            //            resolve(responseStock);
            //        });
            //    }
            //    else {
            //        resolve(responseStock);
            //        //console.log('Missing qty');
            //    }
            //});
        })
    },
    removeCartItem({ commit }, cartItem) {
        //console.log(cartItem);
        //axios.delete('/api/cart', cartItem).then((response) => {
        axios.post('/api/cart/delete', cartItem).then((response) => {
            commit('UPDATE_CART_ITEMS', response.data)
        });
    },
    updateHours({ commit }, updateModel) {
        console.log('updateModel:',updateModel);
        axios.post('/api/cart/update-hours', updateModel).then((response) => {
            commit('UPDATE_CART_ITEMS', response.data)
        });
    },
    //sendCartOrder({ commit }, order) {
    //    //console.log(cartItem);
    //    axios.post('/api/cart/send', order).then((response) => {
    //        commit('UPDATE_CART_ITEMS', response.data)
    //    });
    //},
    removeAllCartItems({ commit }, id) {
        //console.log('delete', this.getUID);
        if (confirm("Are you sure to delete ?")) {
            axios.delete('/api/cart/delete/all/' + id).then((response) => {
                commit('UPDATE_CART_ITEMS', response.data)
            });
        }

    },
    closeOrder({ commit }) {
        //console.log('delete', this.getUID);
        var cartItems = { totalQty: 0, totalPrice: 0, basketItems: [] };
        commit('UPDATE_CART_ITEMS', cartItems)
    }
}

const getters = {
    cartItems: state => state.cartItems,
    cartTotal: state => state.cartItems.totalPrice,
    cartQuantity: state => state.cartItems.totalQty
    //cartTotal: state => {
    //    return state.cartItems.reduce((acc, cartItem) => {
    //        return (cartItem.qty * cartItem.price) + acc;
    //    }, 0).toFixed(2);
    //},
    //cartQuantity: state => {
    //    return state.cartItems.reduce((acc, cartItem) => {
    //        return cartItem.qty + acc;
    //    }, 0);
    //}
}

const cartModule = {
    state,
    mutations,
    actions,
    getters
}
export default cartModule;